module.exports = __webpack_public_path__ + "img/example.9b27f999.png";